import { FAILED, LOADING, SUCCESS } from './constants';

export const initialState = {
  dataTermCondition: {},
  isLoadingTermCondition: false,
  messageTermCondition: '',
  dataSubPangkalanTermCondition: [],
  isLoadingSubPangkalanTermCondition: false,
  messageSubPangkalanTermCondition: '',
  isLoadingUpdateSubPangkalanTermCondition: false,
  dataUpdateSubPangkalanTermCondition: {},
  messageUpdateSubPangkalanTermCondition: '',
  dataTermConditionById: null,
  isLoadingTermConditionById: false,
  messageTermConditionById: '',
  dataTermConditionHistory: { data: [], meta: {} },
  isLoadingTermConditionHistory: false,
  messageTermConditionHistory: ''
};

export default function reducer(state = initialState, action) {
  const { type, data, isLoading, message, key } = action;

  switch (type) {
    case FAILED:
      return {
        ...state,
        [`data${key}`]: initialState[`data${key}`],
        [`isLoading${key}`]: false,
        [`message${key}`]: message,
      };
    case LOADING:
      return {
        ...state,
        [`isLoading${key}`]: isLoading,
        [`message${key}`]: '',
      };
    case SUCCESS: {
      if (key === 'TermConditionHistory') {
        const currentPage = data.meta?.page || 1;
        const existingData = currentPage > 1 ? state.dataTermConditionHistory.data : [];

        return {
          ...state,
          dataTermConditionHistory: {
            data: [...existingData, ...(data.data || [])],
            meta: data.meta || {}
          },
          isLoadingTermConditionHistory: false,
          messageTermConditionHistory: data?.message || ''
        };
      }

      const processedData = data?.data || data;

      return {
        ...state,
        [`data${key}`]: processedData,
        [`isLoading${key}`]: false,
        [`message${key}`]: message || '',
      };
    }
    default:
      return state;
  }
}
